import type { MailboxInfo } from 'owa-client-types';
import { getAccountScopeUserSettings } from '../selectors/getAccountScopeUserSettings';

export default function getFavorites(mailboxInfo: MailboxInfo) {
    return getAccountScopeUserSettings(mailboxInfo).Favorites;
}
